import { AUDIENCE_STATUS } from 'modules/audiences/config/audiencesConsts';
import { MODULE_NAME as AUDIENCES_MODULE } from 'modules/audiences/config/routes';
import { checkCreateLookalikePermitted } from 'modules/audiences/hooks/useCreateLookalikePermitted';
import { checkPixelLookalikePermitted } from 'modules/audiences/hooks/usePixelLookalikePermitted';
import { FEATURE_FLAGS } from 'modules/taboola-common-frontend-modules/account-configurations';
import * as FIELDS from '../../fields';
import { FILTER_TYPE } from '../../filters';
import { REPORT_PRESET } from '../../pickers';
import columnDefinitions from './columnDefinitions';
import { PREDICTIVE_REPORT_ID } from './predictiveReportId';
import { customColumns, defaultColumns } from './reportPresets';

export const lookLikeReportConfig = {
    id: PREDICTIVE_REPORT_ID,
    label: 'Predictive Audiences',
    visibilityCondition: ({ permissions, configs: { selectedAccountConfig }, selectedAccount }) => {
        const isCrmLookalikeAllowed = checkCreateLookalikePermitted({
            permissions,
            selectedAccountConfig,
        });
        const isPbpAllowed = checkPixelLookalikePermitted({
            permissions,
            selectedAccountConfig,
            selectedAccount,
            advertiserType: selectedAccount?.advertiserType,
            associatedAccountAdvertiserTypes: selectedAccount?.associatedAccountAdvertiserTypes,
        });

        return isPbpAllowed || isCrmLookalikeAllowed;
    },
    module: AUDIENCES_MODULE,
    endpoint: 'lookalike-audience-report',
    rowIdField: FIELDS.ID.field,
    columnsDef: columnDefinitions,
    presets: {
        [REPORT_PRESET.DEFAULT]: { columns: defaultColumns },
    },
    customPreset: { columns: customColumns, initialState: defaultColumns },
    footerColumnDef: [],
    isEmptyFooter: true,
    searchPlaceholderMsgId: 'app.reports.predictive.search.placeholder',

    // TODO: DEV-58584 need to convert filter names in the GW. replace sortField + remove sortMap
    // searchField: NAME.field
    searchField: FIELDS.AUDIENCE_NAME.field,
    sortMap: {
        [FIELDS.NAME.field]: FIELDS.AUDIENCE_NAME.field,
    },
    initialFilters: [
        {
            id: FILTER_TYPE.AUDIENCE_STATUS,
            type: FILTER_TYPE.AUDIENCE_STATUS,
            values: [
                {
                    value: AUDIENCE_STATUS.ALL_BUT_ARCHIVED,
                    label: 'All but archived',
                    messageId: 'report.audienceStatus.ALL_BUT_ARCHIVED',
                },
            ],
            accountConfigurations: { [FEATURE_FLAGS.REPORT_AUTO_FILTERS]: 'true' },
        },
    ],
    filters: [{ id: FILTER_TYPE.AUDIENCE_STATUS }],
};

export default lookLikeReportConfig;
